import { render, staticRenderFns } from "./resourceStoreTypeManage.vue?vue&type=template&id=91d66c12&scoped=true"
import script from "./resourceStoreTypeManage.vue?vue&type=script&lang=js"
export * from "./resourceStoreTypeManage.vue?vue&type=script&lang=js"
import style0 from "./resourceStoreTypeManage.vue?vue&type=style&index=0&id=91d66c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d66c12",
  null
  
)

export default component.exports